import { fetcher } from '@commenda/utils';
import { TEMPLATE_CATEGORIES_URL } from './helpers';
import { TDocumentAssemblerCreateTemplateCategoryParams } from './types';

export const createDocumentAssemblerTemplateCategory = async (
  data: TDocumentAssemblerCreateTemplateCategoryParams
): Promise<Response> => {
  const res = await fetcher(TEMPLATE_CATEGORIES_URL, {
    method: 'POST',
    body: data,
  });
  return res;
};
